import React, { forwardRef } from "react";
import { motion } from "framer-motion";

export const motionFadeVariants = {
    hidden: { opacity: 0 },
    visible: { opacity: 1 },
    exit: { display: "none" },
};

function Fade(props, ref) {
    const { children, style, className, tag, transition, animateExit, ...restProps } = props;
    const Wrapper = motion[tag];

    return (
        <Wrapper
            ref={ref}
            className={className}
            variants={motionFadeVariants}
            animate="visible"
            initial="hidden"
            exit={animateExit ? "hidden" : "exit"}
            style={style}
            transition={transition}
            {...restProps}
        >
            {children}
        </Wrapper>
    );
}

const _Fade = forwardRef(Fade);
_Fade.displayName = "Fade";
_Fade.defaultProps = {
    tag: "div",
    animateExit: true,
};

export default _Fade;
